import RegionsService from '../services/regions.service';
import { Region } from './models/models';

export default {
  namespaced: true,
  state: {
    regionId: null,
  },
  mutations: {
    regionId(state, regionId) {
      state.regionId = regionId;
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getRegions');
    },
    newRegion({ commit }) {
      Region.new()
        .then((region) => {
          commit('regionId', region.id);
        });
    },
    updateRegionProps({ state }, props) {
      Region.update({
        where: state.regionId,
        data: props,
      });
    },
    getRegions() {
      return RegionsService.getRegions()
        .then((res) => {
          Region.create({ data: res });
        });
    },
    suggestRegions(store, query) {
      return RegionsService.suggestRegions(query);
    },
    getRegion({ commit }, id) {
      return RegionsService.getRegion(id)
        .then((region) => {
          Region.insert({ data: [region] })
            .then(() => {
              commit('regionId', region.id);
            });
        });
    },
    createRegion({ getters }) {
      return RegionsService.createRegion(getters.region);
    },
    updateRegion({ getters, dispatch }) {
      return RegionsService.updateRegion(getters.region)
        .then((res) => {
          if (res.hasOwnProperty('region_id')) {
            dispatch('getRegion', res.region_id);
          }
          return res;
        });
    },
    deleteRegion({ getters }) {
      return RegionsService.deleteRegion(getters.region)
        .then((res) => {
          if (res.hasOwnProperty('region_id')) {
            Region.delete(res.region_id);
          }
          return res;
        });
    },
  },
  getters: {
    regions() {
      return Region.all();
    },
    region(state) {
      if (!state.regionId) {
        return null;
      }
      return Region.query()
        .find(state.regionId);
    },
  },
};
